import { Hub } from '@aws-amplify/core';

export const setAutoSaveMessage = ({ event = null, data = null, message = '' } = {}) => {
  Hub.dispatch('autosave', { event, data, message });
};
